import { accessObjectViaString } from '../../common/functions/helpers';
import api from '../../common/api';
import dfpService from '../../services/dfpService';
import accountService from '../../services/accountService';

const mutations = {
  setUseraccountChannels(state, data) {
    state.useraccount.channels = data;
  },
  setUseraccountNetworks(state, data) {
    state.useraccount.networks = data;
  },
	setSiteuser(state, data) {
		state.siteuser = data;
	},
	setSiteuserAccount(state, data) {
		state.useraccount = data;
	},
  setUseraccountMediasources(state, data) {
    state.useraccount.mediasources = data;
  },
  apiFailure: (context, err) => {
      // alert("ERROR" + err);
      console.log(err);
  },
  enableGoogleDfp(state) {
    state.useraccount.googleAuth = true;
  }
};

const actions = {
  loadSiteuser({ commit }) {
    commit('setSiteuser', JSON.parse(window.localStorage.getItem('profile')));
  },
  loadSiteuserAccount({ commit, state }) {
    const accountID = state.siteuser.user_metadata.account_id;
    return accountService.get(accountID)
      .then(response => commit('setSiteuserAccount', response.data.account))
      .catch(error => commit('apiFailure', error));
  },
  loadUseraccountChannels({ commit }) {
    return api.get('/item/channel')
            .then((response) => commit('setUseraccountChannels', response.data.results))
            .catch((error) => commit('store apiFailure Channel', error));
  },
  loadUseraccountNetworks({ commit }) {
    return api.get('/item/network')
            .then((response) => commit('setUseraccountNetworks', response.data.results))
            .catch((error) => commit('store apiFailure Networks', error));
  },
  loadUseraccountMedia({ commit }) {
    return api.get('/item/mediaitem')
            .then((response) => {return response})
            .catch((error) => commit('store apiFailure', error));
  },
  loadUseraccountMediasources({commit}, id) {
    return api.get('/item/mediasource')
            .then((response) => commit('setUseraccountMediasources', response.data.results))
            .catch((error) => commit('store apiFailure Mediasources', error));
  },
  enableDfp({ state, commit }) {
    const enabled = state.useraccount.googleAuth;
    if (enabled) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const authWindow = dfpService.authenticateWithGoogle();
      const timer = setInterval(() => {
        if (authWindow.closed) {
          clearInterval(timer);
          const authSuccessKey = 'googleOAuthSuccess';
          const authWasSuccessful = localStorage.getItem(authSuccessKey);
          localStorage.removeItem(authSuccessKey);
          if (authWasSuccessful) {
            commit('enableGoogleDfp');
            resolve();
          } else {
            reject();
          }
        }
      }, 200);
    });
  }
};

const getters = {
  hasGoogleDfpEnabled(state) {
    return state.useraccount.googleAuth;
  },
  currentAccountName(state) {
    return state.useraccount.name;
  },
  getConfigValue(state, config) {
    if (state.useraccount.config && state.useraccount.config[config]) {
      return state.useraccount.features[config];
    } else {
      return 0;
    }
  },
  getFeatureValue(state) {
    return (feature) => {
      if (state.useraccount.features && state.useraccount.features[feature]) {
        return state.useraccount.features[feature];
      } else {
        return false;
      }
    };
  }
};

const state = {
  siteuser: {},
  useraccount: {}
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js